/*
 * JS For Featured Blog Slider
 * epicaffect
 */

(function($) {

    var blogslider = new Swiper('.blogslider', {
        slidesPerView   : 1,
        effect          : 'fade',
        loop            : true,
        pagination      : {
            el: '.swiper-pagination',
            clickable: true,
            // renderBullet: function (index, className) {
            //     return '<span class="' + className + '">' + (index + 1) + '</span>';
            // },
        },
    });
    
})(jQuery);
